import enTranslations from './en.json';
import arTranslations from './ar.json';

export type Locale = 'en' | 'ar';

export const translations: Record<Locale, typeof enTranslations> = {
  en: enTranslations,
  ar: arTranslations as unknown as typeof enTranslations,
} as const;

export type TranslationKeys = typeof enTranslations;
